export const columns = [
  {
    Header: 'Student ID',
    accessor: 'Id',
    filterable: true,
  },
  {
    Header: 'Last Name',
    accessor: 'LastName',
    filterable: true,
  },
  {
    Header: 'First Name',
    accessor: 'FirstName',
    filterable: true,
  },
  {
    Header: 'Teacher',
    accessor: 'Teacher',
    filterable: true,
  },
  {
    Header: 'Grade',
    accessor: 'GradeId',
    filterable: true,
  },
];



// WEBPACK FOOTER //
// ./src/pages/prohibiteditems/helpers/columns.js